const KYC_BIZUM_WS_TIME_PROPS = {
  timeout: 240, // seconds
};

export { KYC_BIZUM_WS_TIME_PROPS };
